export function stripTrailingZeroes(str) {
    for (let i=str.length - 1; i >= 0; i--) {
        if (str.slice(i, i + 1) !== '0') {
            return str.slice(0, i + 1);
        }
    }
}

export function stripLeadingZeroes(str) {
    for (let i=0; i < str.length; i++) {
        if (str.slice(i, i+1) !== '0') {
            return str.slice(i);
        }
    }
}
